import { compose, hoistStatics } from 'recompose';
import mlHelper from '../../helpers/ml.helper';
import Menus from './Menus';

const enhance = compose(
  mlHelper.core,
);

export default hoistStatics(enhance)(Menus);



// WEBPACK FOOTER //
// ./src/views/menus/index.js